import { Logo } from "@/components/Logo";
import { goTo } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const EXPLORE = [
  ["services", "#services"],
  ["recovery", "#recovery"],
  ["claim", "#claim"],
  ["about", "#about"],
  ["consult", "#consult"],
  ["faq", "#faq"],
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-gold/15 bg-abyss">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
        <div className="grid gap-12 md:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <div>
            <div className="flex items-center gap-3">
              <Logo className="h-12 w-12" />
              <div>
                <p className="font-display text-xl font-semibold tracking-[0.12em] text-cream">DUSTIN CAMPOS</p>
                <p className="font-mono text-[9px] uppercase tracking-[0.26em] text-gold/80">
                  {t.nav.license}
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/55">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">{t.footer.explore}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {EXPLORE.map(([key, hash]) => (
                <li key={hash}>
                  <a href={hash} onClick={(e) => goTo(e, hash)} className="text-cream/60 transition-colors duration-300 hover:text-gold" data-testid={`footer-link-${key}`}>
                    {key === "claim" ? t.claim.footerLink : t.footer.exploreLinks[key]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">{t.footer.contact}</p>
            <ul className="mt-5 space-y-3 text-sm text-cream/60">
              <li>
                <a href="tel:+18085004711" className="transition-colors duration-300 hover:text-gold" data-testid="footer-call-link">
                  {t.footer.call} 808-500-4711
                </a>
              </li>
              <li>
                <a href="sms:+18082984096" className="transition-colors duration-300 hover:text-gold" data-testid="footer-text-link">
                  {t.footer.text} 808-298-4096
                </a>
              </li>
              <li>
                <a
                  href="https://calendly.com/thedustincampos/1hr-in-person"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors duration-300 hover:text-gold"
                  data-testid="footer-calendly-link"
                >
                  {t.footer.calendly}
                </a>
              </li>
              <li className="text-cream/45">{t.footer.location}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-cream/10 pt-8">
          <p className="text-xs leading-relaxed text-cream/40">
            {t.footer.disclaimer}
          </p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-cream/35">
            &copy; {new Date().getFullYear()} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
